import { Col, Form, Input, message, Row } from "antd";
import StepsProgress from "organisms/StepsProgress";
import React, { useState } from "react";
import styled from "styled-components";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { connect, useSelector } from "react-redux";
import { getClientid, getUserInfo, getUserMenuList } from "redux/selectors";
import RolesAndPermissions from "./RolesAndPermissions";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { setMenuList, setRoleList, setUserList } from "redux/actions";
import { bindActionCreators } from "redux";
import SuccessPopup from "./SuccessPopup";

const AddRoleWrapp = styled.div`
  position: relative;
  height: calc(100vh - 150px);
`;

const AddRole = ({
  toggleAddRole,
  roleList,
  getRoleList,
  saveRoleList,
  updateUserList,
  saveMenuList,
}) => {
  const clientId = useSelector(getClientid);
  const userInfo = useSelector(getUserInfo);
  const userMenuList = useSelector(getUserMenuList);
  const [form] = Form.useForm();
  const containerRef = React.useRef(null);
  const [formValues, setFormValues] = useState({});
  const [step, setStep] = useState(0);
  const [menuList, setMenuList] = useState(userMenuList);
  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const fetchMasterData = async (fetch_master_data) => {
    const { code, roleList, userList, menuList, userrole } = await CALL_API(
      `master-data/${clientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      if (fetch_master_data) {
        if (userrole === "Owner") {
          saveMenuList(menuList);
        } else {
          saveMenuList(
            userList?.find((user) => user?.userid === userInfo?.userid)
              ?.menulist
          );
        }
        saveRoleList(roleList);
        updateUserList(userList);
      }
    }
  };

  const onFinish = async (menuList) => {
    const rolename = form.getFieldValue("rolename");
    setLoading(true);
    const { code } = await CALL_API(`owner-roles/${clientId}`, "post", {
      rolename: rolename,
      menuList: menuList,
      department: [],
      location: [],
    });
    if (code === STATUS_CODE?.SUCCESS) {
      fetchMasterData(true);
      setLoading(false);
      setSuccessModal(true);
      setSuccessMessage("Created Successfully");
      setTimeout(() => {
        setSuccessModal(false);
        setSuccessMessage("");
      }, 3000);
      toggleAddRole(false);
      setStep(0);
      getRoleList();
    }
  };

  const stepdata = [
    { id: 1, title: "Basic" },
    { id: 4, title: "Permission" },
  ];

  const footerStyle = {
    position: "absolute",
    bottom: -40,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  return (
    <AddRoleWrapp>
      <label
        className="bg-transparent border-0 mb-3 text-left styled-cursor"
        onClick={() => toggleAddRole(false)}
      >
        Role <ArrowForwardIosIcon className="px-1" />
      </label>{" "}
      <b className="pb-0 pt-1">Add Role</b>
      <StepsProgress stepdata={stepdata} title="Add Role:" step={step} />
      {step === 0 && (
        <Form
          form={form}
          name="addrole"
          layout="vertical"
          initialValues={formValues}
          onFinish={(values) => {
            setFormValues(values);
            setStep(step + 1);
          }}
        >
          <Row gutter={12}>
            <Col xs={24} sm={24} ref={containerRef}>
              <Form.Item
                label="Role"
                name="rolename"
                rules={[
                  {
                    required: true,
                    message: "Role name is required",
                  },
                  {
                    validator: (rule, value) => {
                      if (value) {
                        const trimmedValue = value.trim();
                        if (
                          roleList?.some(
                            (data) => data.roleName === trimmedValue
                          )
                        ) {
                          return Promise.reject("Role Name already exists");
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  maxLength={20}
                  placeholder="Role Name"
                  onKeyDown={(e) => {
                    const allowedChars = /^[a-zA-Z\s]+$/;
                    if (!allowedChars.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div style={footerStyle}>
            <ButtonOutlined onClick={() => toggleAddRole(false)}>
              Cancel
            </ButtonOutlined>
            <ButtonFilled type="primary" htmlType="submit">
              Next
            </ButtonFilled>
          </div>
        </Form>
      )}
      {step === 1 && (
        <RolesAndPermissions
          step={step}
          setStep={setStep}
          setMenuList={setMenuList}
          menuList={menuList}
          setsubmit={() => {}}
          onFinish={onFinish}
          loading={loading}
          handleCancel={toggleAddRole}
          type="add"
        />
      )}
      <SuccessPopup
        open={successModal}
        close={setSuccessModal}
        text={successMessage}
      />
    </AddRoleWrapp>
  );
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveMenuList: setMenuList,
      updateUserList: setUserList,
      saveRoleList: setRoleList,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps, null)(AddRole);
